import React from 'react';
import { GridItemImage, GridItemText, ImageElement, Text } from './HeaderSection.styled';
import Button from 'components/Button/Button';
import { useAppDispatch } from 'app/hooks';
import {
  saveSelectedItem,
  selectSelectedHeader,
  toggleAllVisibilityHeader,
  toggleIndividualVisibilityHeader,
} from 'features/document/documentSlice';
import { useAppSelector } from 'app/hooks';
import { ButtonContainer, Container, Tag } from './HeaderSection.styled';
import { ElementType, HeaderElement } from 'features/document/constants';
import { useGetFileQuery } from 'features/files/filesApi';
import { GridContainer } from './HeaderSection.styled';

interface Props {
  header: HeaderElement;
  isIndividualHeaderVisible: boolean;
  pageId: string;
}

const HeaderSection: React.FC<Props> = ({ header, isIndividualHeaderVisible, pageId }) => {
  const dispatch = useAppDispatch();
  const selector = useAppSelector;
  const selectedItem = selector(selectSelectedHeader);
  const isSameItem = selectedItem?.data?.id == header.id;

  const { data: backgroundImageData } = useGetFileQuery(Number(header.content.backgroundImage.id), {
    skip: header.content.backgroundImage.id === null,
  });

  const { data: logoData } = useGetFileQuery(Number(header.content.logo.id), {
    skip: header.content.logo.id === null,
  });

  const handleSelectedItem = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(saveSelectedItem({ data: { data: header, pageId, type: ElementType.Header } }));
  };
  const { content, style } = header;

  const handleToggleIndividualHeader = () => {
    dispatch(
      toggleIndividualVisibilityHeader({
        pageId,
        isVisible: isIndividualHeaderVisible,
      })
    );
  };

  const handleToggleAllPages = () => {
    dispatch(
      toggleAllVisibilityHeader({
        isVisible: isIndividualHeaderVisible,
      })
    );
  };
  return (
    <Container
      aria-hidden='true'
      onClick={handleSelectedItem}
      isSameItem={isSameItem}
      isVisible={isIndividualHeaderVisible}
      backgrounImageOpacity={style.backgroundImageOpacity}
      backgroundColor={content.hasBackgroundColor && isIndividualHeaderVisible ? style.backgroundColor : ''}
      backgroundImage={content.hasBackgroundImage && content.backgroundImage.id ? backgroundImageData?.data.url : ''}
      backgroundCover={style.backgroundCover}
      backgroundPosition={style.backgroundPosition}
    >
      {isIndividualHeaderVisible && (
        <Tag className='containerTag' isSameItem={isSameItem}>
          Header
        </Tag>
      )}
      <ButtonContainer isSameItem={isSameItem} style={{ zIndex: isIndividualHeaderVisible ? '99' : '0' }}>
        <Button variant='secondary' onClick={handleToggleIndividualHeader}>
          {isIndividualHeaderVisible ? 'Turn off header for this page' : 'Turn on header for this page'}
        </Button>
        <Button
          variant='secondary'
          onClick={handleToggleAllPages}
        >{`Turn ${isIndividualHeaderVisible ? 'off' : 'on'} header for all pages`}</Button>
      </ButtonContainer>
      {isIndividualHeaderVisible && (
        <GridContainer container justifyContent='space-between' alignItems='center'>
          <GridItemImage item xs={4} display='flex'>
            {content.hasLogo && content.logo.id && <ImageElement src={logoData?.data.url} alt='logo' />}
          </GridItemImage>
          <GridItemText item xs={6}>
            <Text fontSize={style.labelFontSize} labelFont={style.labelFont} fontColor={style.fontColor}>
              {content.hasHeaderDetails && content?.text}
            </Text>
          </GridItemText>
        </GridContainer>
      )}
    </Container>
  );
};

export default HeaderSection;
